import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';

import { FulfillmentPlanOrderGridStatus } from '../../../enums/fulfillmentplan-order-grid-status';

const useCustomsIsReadOnly = (fulfillmentPlanId) => {
  const fulfillmentPlan = useSelector((state) => Global.selectEntitiesFulfillmentPlanById(state, { fulfillmentPlanId }));
  const { orderGridStatus } = fulfillmentPlan;
  const readOnly = orderGridStatus === FulfillmentPlanOrderGridStatus.Shipped.name;

  return readOnly;
};

export default useCustomsIsReadOnly;
